import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

// PrimeNG
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

import { Ticket } from '../ticket-management.component';
import { ApiService } from '../../../../services/api.service';

export interface StatusHistory {
  id: number;
  userId: number;
  userName: string;
  oldStatus: string;
  newStatus: string;
  changedAt: Date;
}

@Component({
  selector: 'app-status-history-modal',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule
  ],
  templateUrl: './status-history-modal.component.html',
  styleUrls: ['./status-history-modal.component.css']
})
export class StatusHistoryModalComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  // @Input() ticket: Ticket | null = null;
  @Output() close = new EventEmitter<void>();
  @Input() ticket: any;


  statusHistory: StatusHistory[] = [];
constructor(private api: ApiService) {}
  ngOnInit(): void {
    if (this.ticket) {
      this.loadStatusHistory();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible && this.ticket) {
      this.loadStatusHistory();
    }
  }

  // loadStatusHistory(): void {
  //   // Mock data - Replace with actual API call
  //   if (this.ticket) {
  //     // Generate mock status history based on ticket
  //     this.statusHistory = [
  //       {
  //         id: 1,
  //         userId: 'DSP_DADMIN',
  //         userName: 'DSP_DADMIN',
  //         oldStatus: 'open',
  //         newStatus: 'closed',
  //         changedAt: new Date('2025-01-28T16:06:30')
  //       },
  //       {
  //         id: 2,
  //         userId: 'ILIZIEN',
  //         userName: 'ILIZIEN',
  //         oldStatus: 'closed',
  //         newStatus: 'in_progress',
  //         changedAt: new Date('2025-02-03T14:34:53')
  //       },
  //       {
  //         id: 3,
  //         userId: 'ILIZIEN',
  //         userName: 'ILIZIEN',
  //         oldStatus: 'in_progress',
  //         newStatus: 'resolved',
  //         changedAt: new Date('2025-02-04T13:51:57')
  //       },
  //       {
  //         id: 4,
  //         userId: 'ILIZIEN',
  //         userName: 'ILIZIEN',
  //         oldStatus: 'resolved',
  //         newStatus: 'closed',
  //         changedAt: new Date('2025-02-04T15:30:00')
  //       }
  //     ];
  //   }
  // }

  getStatusColor(status: string): string {
    const statusLower = status.toLowerCase();
    if (statusLower.includes('open') || statusLower.includes('reopen')) {
      return 'bg-blue-100 text-blue-800 border-blue-200';
    } else if (statusLower.includes('progress')) {
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    } else if (statusLower.includes('resolved')) {
      return 'bg-green-100 text-green-800 border-green-200';
    } else if (statusLower.includes('closed')) {
      return 'bg-red-100 text-red-800 border-red-200';
    }
    return 'bg-gray-100 text-gray-800 border-gray-200';
  }

  getStatusIcon(status: string): string {
    const statusLower = status.toLowerCase();
    if (statusLower.includes('open') || statusLower.includes('reopen')) {
      return 'fa-circle';
    } else if (statusLower.includes('progress')) {
      return 'fa-ellipsis';
    } else if (statusLower.includes('resolved')) {
      return 'fa-check';
    } else if (statusLower.includes('closed')) {
      return 'fa-times';
    }
    return 'fa-circle';
  }

  getStatusIconColor(status: string): string {
    const statusLower = status.toLowerCase();
    if (statusLower.includes('open') || statusLower.includes('reopen')) {
      return 'text-blue-500';
    } else if (statusLower.includes('progress')) {
      return 'text-yellow-500';
    } else if (statusLower.includes('resolved')) {
      return 'text-green-500';
    } else if (statusLower.includes('closed')) {
      return 'text-red-500';
    }
    return 'text-gray-500';
  }

  formatDate(date: Date): string {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }).format(date);
  }

  onClose(): void {
    this.close.emit();
  }

  onHide(): void {
    this.close.emit();
  }
loadStatusHistory(): void {

  if (!this.ticket?.id) return;

  const url = `/ticket/${this.ticket.id}/activities/`;

  this.api.getAPI(url).subscribe((res: any) => {

    console.log("Activities API:", res);

    if (res?.data) {

      this.statusHistory = res.data.map((item: any) => ({
        id: item.id,

        userId: item.user,

        userName: item.user_info
          ? `${item.user_info.first_name} ${item.user_info.last_name}`
          : 'Unknown',

        oldStatus: item.old_value || 'N/A',

        newStatus: item.new_value || 'N/A',

        changedAt: new Date(item.created_on)
      }));

    }

  });

}
}

